import type { SessionData } from "../types";
import { Icon } from "./Icon";

interface AccountPanelProps {
  open: boolean;
  session: SessionData | null;
  onClose: () => void;
  onOpenAdmin: () => void;
  onSignOut: () => void;
  onDeleteAccount: () => void;
}

export function AccountPanel({ open, session, onClose, onOpenAdmin, onSignOut, onDeleteAccount }: AccountPanelProps) {
  if (!open || !session) return null;

  return (
    <div className="account-popover" role="dialog" aria-label="账户菜单">
      <button className="popover-scrim" aria-label="关闭账户菜单" onClick={onClose} type="button" />
      <section>
        <header>
          <span className="account-avatar large">{session.user.name.slice(0, 1).toUpperCase()}</span>
          <div><strong>{session.user.name}</strong><span>{session.user.email}</span></div>
        </header>
        <p className="verification-row"><span className={`status-dot ${session.user.emailVerified ? "" : "is-warning"}`} />{session.user.emailVerified ? "邮箱已验证" : "邮箱尚未验证"}</p>
        {session.isAdmin ? <button onClick={onOpenAdmin} type="button"><Icon name="settings" />数据源管理</button> : null}
        <button onClick={onSignOut} type="button"><Icon name="logout" />退出登录</button>
        <button className="danger-action" onClick={onDeleteAccount} type="button"><Icon name="trash" />注销账户并删除云端数据</button>
      </section>
    </div>
  );
}
